import { render, staticRenderFns } from "./history-detailed.vue?vue&type=template&id=20b91a7b&scoped=true&"
import script from "./history-detailed.vue?vue&type=script&lang=js&"
export * from "./history-detailed.vue?vue&type=script&lang=js&"
import style0 from "./history-detailed.vue?vue&type=style&index=0&id=20b91a7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b91a7b",
  null
  
)

export default component.exports